export default __webpack_public_path__ + "static/media/robotics_mobile.214e9926.jpg";